import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="bg-gradient-to-br from-teal-50 to-blue-50 rounded-3xl p-12 md:p-16 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            지금 시작하세요
          </h2>
          <p className="text-xl text-gray-600 mb-12 max-w-2xl mx-auto">
            달란트 플랫폼과 함께 더 풍성한 신앙 생활을 경험하세요
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/auth/signup"
              className="px-8 py-4 bg-teal-600 text-white text-lg font-semibold rounded-lg hover:bg-teal-700 transition-colors shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              무료로 시작하기
            </Link>
            <Link
              to="/talent"
              className="px-8 py-4 bg-white text-gray-800 text-lg font-semibold rounded-lg hover:bg-gray-50 transition-colors shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              더 알아보기
            </Link>
          </div>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="text-4xl font-bold text-teal-600 mb-2">10,000+</div>
              <p className="text-gray-600">활성 사용자</p>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-teal-600 mb-2">500+</div>
              <p className="text-gray-600">참여 교회</p>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-teal-600 mb-2">50,000+</div>
              <p className="text-gray-600">콘텐츠 & 상품</p>
            </div>
          </div>
        </div>

        {/* 파트너 섹션 */}
        <div className="mt-20">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-10">파트너</h3>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 max-w-5xl mx-auto">
            <Link
              to="/merchant/login"
              className="bg-white rounded-xl p-8 text-center hover:shadow-lg transition-all border border-gray-200 hover:border-teal-500 cursor-pointer group"
            >
              <div className="w-16 h-16 mx-auto mb-4 bg-teal-100 rounded-full flex items-center justify-center group-hover:bg-teal-200 transition-colors">
                <i className="ri-store-2-line text-3xl text-teal-600"></i>
              </div>
              <h4 className="text-lg font-semibold text-gray-900 mb-2">상품 판매자</h4>
              <p className="text-sm text-gray-600">신앙 상품 판매</p>
            </Link>

            <Link
              to="/supplier/login"
              className="bg-white rounded-xl p-8 text-center hover:shadow-lg transition-all border border-gray-200 hover:border-teal-500 cursor-pointer group"
            >
              <div className="w-16 h-16 mx-auto mb-4 bg-teal-100 rounded-full flex items-center justify-center group-hover:bg-teal-200 transition-colors">
                <i className="ri-truck-line text-3xl text-teal-600"></i>
              </div>
              <h4 className="text-lg font-semibold text-gray-900 mb-2">상품 공급사</h4>
              <p className="text-sm text-gray-600">도매 상품 공급</p>
            </Link>

            <Link
              to="/content-supplier/login"
              className="bg-white rounded-xl p-8 text-center hover:shadow-lg transition-all border border-gray-200 hover:border-teal-500 cursor-pointer group"
            >
              <div className="w-16 h-16 mx-auto mb-4 bg-teal-100 rounded-full flex items-center justify-center group-hover:bg-teal-200 transition-colors">
                <i className="ri-video-line text-3xl text-teal-600"></i>
              </div>
              <h4 className="text-lg font-semibold text-gray-900 mb-2">콘텐츠 공급사</h4>
              <p className="text-sm text-gray-600">신앙 콘텐츠 제공</p>
            </Link>

            <Link
              to="/church-admin/login"
              className="bg-white rounded-xl p-8 text-center hover:shadow-lg transition-all border border-gray-200 hover:border-teal-500 cursor-pointer group"
            >
              <div className="w-16 h-16 mx-auto mb-4 bg-teal-100 rounded-full flex items-center justify-center group-hover:bg-teal-200 transition-colors">
                <i className="ri-community-line text-3xl text-teal-600"></i>
              </div>
              <h4 className="text-lg font-semibold text-gray-900 mb-2">커뮤니티 관리자</h4>
              <p className="text-sm text-gray-600">교회 커뮤니티 관리</p>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
